import { Box, HStack, Tag } from '@chakra-ui/react';
import { type FC } from 'react';

import { scrollable } from '$/components/common/Scrollbar';
import { GenericTagContent } from '$/components/core/Collection/MaterialPresentation/DataSortingRow/components/GenericTagContent';
import { type FilterOptionGroup } from '$/services/usecases/filter';
import { useCollectionStore } from '$/stores/useCollectionStore';

interface Props {
  filterGroup: FilterOptionGroup;
}

export const MobileFilterMulti: FC<Props> = ({ filterGroup }) => {
  return (
    <Box {...scrollable({ x: 'scroll', y: 'hidden' })}>
      <HStack gap='2' mt='2' pt='2' pr='4' pb='2'>
        {filterGroup.items.map((item) => {
          return (
            <Tag
              key={item.value}
              layerStyle={
                useCollectionStore
                  .getState()
                  .isFilterActive(filterGroup.searchField, item.value)
                  ? 'FilterTagSelected'
                  : 'FilterTag'
              }
              h='32px'
              px='4'
              borderColor='border'
              borderRadius='full'
              cursor='pointer'
              onClick={() => {
                useCollectionStore
                  .getState()
                  .toggleAppliedFilterOption(
                    { option: filterGroup.searchField, value: item.value },
                    { isMultiFilter: true },
                  );
              }}
            >
              <GenericTagContent
                label={item.displayName}
                color={item.payload}
                hideLabel={false}
              />
            </Tag>
          );
        })}
      </HStack>
    </Box>
  );
};
